import React from 'react';
import { ReactThreeFiber } from 'react-three-fiber';
import { CustomObject } from '../../../types/data';
import { Text } from 'drei';
import { useTexture } from '../../../hooks';
import { PUBLIC_URL_ROOT } from '../../../config/secrets';
import Rating from '../../../components/xr/rating';
import Button from '../../../components/xr/button';

import bookBtn from '../../../assets/images/xr/icons/book-btn.png';
import { isIOS } from '../../../common/device';

const fontWeblysleek = `${PUBLIC_URL_ROOT}assets/fonts/weblysleek/weblysleekui_bold.ttf`;
const fontRoboto = `${PUBLIC_URL_ROOT}assets/fonts/roboto/roboto.medium.ttf`;

const fontFamily = isIOS() ? fontRoboto : fontWeblysleek;

type BookingWindowProps = {
  data: CustomObject;

  position?: ReactThreeFiber.Vector3;
};

const BookingWindow = ({ data = {}, position }: BookingWindowProps) => {
  const { texture: bookBtnTxt } = useTexture(bookBtn);

  return (
    <mesh position={position}>
      <planeBufferGeometry args={[0.65, 0.1]} attach="geometry" />
      <meshBasicMaterial attach="material" color="#ffffff" />
      <Text
        position={[-0.3, 0.03, 0.0001]}
        color="#000"
        font={fontFamily}
        fontSize={0.019}
        maxWidth={0.45}
        lineHeight={1.1}
        textAlign="left"
        anchorX="left"
        anchorY="top">
        {data.title}
      </Text>

      <group position={[0, -0.01, 0.0001]}>
        <group position={[-0.3, 0, 0]}>
          <Text
            position={[0, 0, 0]}
            color="#000"
            font={fontFamily}
            fontSize={0.019}
            maxWidth={0.1}
            lineHeight={1.3}
            textAlign="left"
            anchorX="left"
            anchorY="top">
            {data.duration}
          </Text>

          <Rating value={data.rating} position={[0.1, -0.01, 0.0001]} />

          <Text
            position={[0.25, 0, 0]}
            color="#000"
            font={fontFamily}
            fontSize={0.019}
            maxWidth={0.1}
            lineHeight={1.3}
            textAlign="left"
            anchorX="left"
            anchorY="top">
            ${data.price}
          </Text>
        </group>
        <group position={[0.22, 0.01, 0]}>
          <Button
            defaultState={{
              main: {
                width: 0.17,
                height: 0.05,
                material: {
                  map: bookBtnTxt,
                  transparent: true,
                },
              },
            }}
            onClick={() => {
              window.location.href = data.booking_url;
            }}>
            <Text
              position={[0, 0, 0.0001]}
              color="#fff"
              font={fontFamily}
              fontSize={0.019}
              maxWidth={0.14}
              lineHeight={1.3}
              textAlign="center"
              anchorX="center"
              anchorY="middle">
              BOOK NOW
            </Text>
          </Button>
        </group>
      </group>
    </mesh>
  );
};

export default BookingWindow;
